import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/**
 * Utility to export table data to Excel
 * @param {string} tableId - ID of the HTML table to export
 * @param {string} fileName - Name of the output file
 * @param {Array} heading - Optional array of strings for report header
 */
export const exportTableToExcel = (tableId, fileName = 'Report', heading = []) => {
    const table = document.getElementById(tableId);
    if (!table) {
        console.error(`Table with ID ${tableId} not found.`);
        return;
    }

    // Clone the table to remove action columns or other elements we don't want in Excel
    const tableClone = table.cloneNode(true);

    // Remove columns with class 'no-print' or last column if it contains action buttons
    tableClone.querySelectorAll('.no-print').forEach(el => el.remove());

    // Check if last column is an action column (common pattern in this app)
    const rows = tableClone.querySelectorAll('tr');
    rows.forEach(row => {
        const cells = row.querySelectorAll('th, td');
        if (cells.length > 0) {
            const lastCell = cells[cells.length - 1];
            // If last cell contains buttons or icons, likely an action column
            if (lastCell.querySelector('button, svg, .btn')) {
                lastCell.remove();
            }
        }
    });

    const workbook = XLSX.utils.table_to_book(tableClone, { sheet: "Sheet1" });
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });

    saveAs(data, `${fileName}_${new Date().getTime()}.xlsx`);
};

/**
 * Export raw JSON data to Excel
 * @param {Array} data - Array of objects
 * @param {string} fileName - Name of the output file
 */
export const exportJsonToExcel = (data, fileName = 'DataExport') => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const excelData = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(excelData, `${fileName}_${new Date().getTime()}.xlsx`);
};
